export default function DocumentSkeleton() {
  return null;
}
